export default "__VITE_ASSET__CncRfbrb__"